import { ArrayUtil } from '../util';
export class DelayedCalls {
    constructor() {
        this.delayedCalls = [];
    }
    get isInitialized() {
        return Boolean(this.client);
    }
    initialize(client) {
        this.client = client;
        for (const call of this.delayedCalls) {
            call(this.client);
        }
        ArrayUtil.clear(this.delayedCalls);
    }
    makeCall(call) {
        if (this.client) {
            call(this.client);
        }
        else {
            this.delayedCalls.push(call);
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsYXllZENhbGxzLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInRyYWNraW5nL2RlbGF5ZWRDYWxscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBSW5DLE1BQU0sT0FBZ0IsWUFBWTtJQUFsQztRQUdtQixpQkFBWSxHQUErQixFQUFFLENBQUE7SUFzQmhFLENBQUM7SUFwQkMsSUFBVyxhQUFhO1FBQ3RCLE9BQU8sT0FBTyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUM3QixDQUFDO0lBRVMsVUFBVSxDQUFFLE1BQWU7UUFDbkMsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUE7UUFFcEIsS0FBSyxNQUFNLElBQUksSUFBSSxJQUFJLENBQUMsWUFBWSxFQUFFO1lBQ3BDLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUE7U0FDbEI7UUFDRCxTQUFTLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxZQUFZLENBQUMsQ0FBQTtJQUNwQyxDQUFDO0lBRVMsUUFBUSxDQUFFLElBQXlCO1FBQzNDLElBQUksSUFBSSxDQUFDLE1BQU0sRUFBRTtZQUNmLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUE7U0FDbEI7YUFBTTtZQUNMLElBQUksQ0FBQyxZQUFZLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO1NBQzdCO0lBQ0gsQ0FBQztDQUNGIn0=